"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.texToMml = void 0;
const liteAdaptor_1 = require("mathjax-full/js/adaptors/liteAdaptor");
const MathItem_1 = require("mathjax-full/js/core/MathItem");
const SerializedMmlVisitor_1 = require("mathjax-full/js/core/MmlTree/SerializedMmlVisitor");
const HTMLDocument_1 = require("mathjax-full/js/handlers/html/HTMLDocument");
const tex_1 = require("mathjax-full/js/input/tex");
const AllPackages_1 = require("mathjax-full/js/input/tex/AllPackages");
// Code adapted from https://github.com/Speech-Rule-Engine/sre-latex/blob/main/tex2mml/tex2mml
const packages = AllPackages_1.AllPackages.filter((name) => name !== "bussproofs");
const InputJax = new tex_1.TeX({ packages });
const html = new HTMLDocument_1.HTMLDocument("", (0, liteAdaptor_1.liteAdaptor)(), { InputJax });
const visitor = new SerializedMmlVisitor_1.SerializedMmlVisitor();
const toMathML = (node) => visitor.visitDefault(node, "");
const texToMml = (tex) => toMathML(html.convert(tex, { display: true, end: MathItem_1.STATE.CONVERT }));
exports.texToMml = texToMml;
